export default {"src":"/_next/static/media/google-sheets.74e82801.svg","height":67,"width":49,"blurWidth":0,"blurHeight":0};